import { useMemo } from "react";

import { useProductsContext } from "../../../Results/state/products";
import { useSortedFilters } from "../../BaseFilter";
import { getEntityFilterCount } from "../helpers";

export const useFilterItemOptions = () => {
  const { entityFilters, loading: loadingFilters } = useSortedFilters();
  const { filters: filtersCount, loading: loadingFiltersCount } = useProductsContext();

  const loading = loadingFilters || loadingFiltersCount;
  const filters = useMemo(
    () => (filtersCount ? getEntityFilterCount(entityFilters, filtersCount) : []),
    [entityFilters, filtersCount]
  );
  return { loading, filters };
};
